  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_Locations = {
  wu_getLocations,
  wu_should_getLocations
};
//----------------------------------------------------------------------------------------------------
function wu_getLocations(reqData) {
  const methName = "wu_getLocations ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/getLocations";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  //const data = {
  //
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      if(resData && resData.returnCode===0){
        localStorage.setItem("locations",                  JSON.stringify(resData));
        localStorage.setItem("locations_RetrieveLastDate", new Date());
      }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_should_getLocations(reqData) {
  //console.log("countries_RetrieveLastDate = "+new Date());
  //console.log("countries_RetrieveLastDate = "+localStorage.getItem("countries_RetrieveLastDate"));

  if(api.cache_Countries_enabled === false){
    return true;
  }

  let locations = {};
  try { locations = JSON.parse(localStorage.getItem("locations")); }catch(err){;}
  if(locations===null || (typeof locations === "undefined")){
    return true;
  }
  if(!locations.locations || locations.locations.length===0){
    return true;
  }

  let UserWSRetrieveLastDate = new Date(localStorage.getItem("locations_RetrieveLastDate"));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      let minsDiff    = (secondsDiff/60);
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>api.cache_Locations_TTL_min){ return true;  }
      else                                    { return false; }
  }
}
//----------------------------------------------------------------------------------------------------
